import { SearchX } from 'lucide-react';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle } from '../ui/empty';
import { T } from '@transifex/react';
import { t } from '@transifex/native';

type NoResultsFoundProps = {
  title?: string;
};

export function NoResultsFound({
  title = t('No results found')
}: NoResultsFoundProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia
          variant="icon"
          className="size-16 bg-primary text-primary-foreground"
        >
          <SearchX />
        </EmptyMedia>
        <EmptyTitle>
          <T _str={title} />
        </EmptyTitle>
      </EmptyHeader>
    </Empty>
  );
}
